import { Controller, useFormContext } from "react-hook-form"
import { MaintenanceType } from "../../utils"
import { Button, DateInput, Label, NumberInput, Select } from "components"
import moment from "moment"
import { FormDataContext } from "../../context"
import { useContext } from "react"

export function FormMaintenance(props: { onSubmit: () => void }) {
    const {formState} = useFormContext<MaintenanceType>()
    const {dataAsset} = useContext(FormDataContext)

    return (
        <section className="py-5 px-6">
            <div className="w-full flex-col flex gap-8">
                <MainteanceDetail />
            </div>
            <div className="mt-10 flex justify-end">
                <Button
                    type="button"
                    color="primary"
                    onClick={props.onSubmit}
                    loading={formState.isSubmitting ? "true" : undefined}
                >
                    {dataAsset?.asset_maintenance_id ? "Update" : "Save"}
                </Button>
            </div>
        </section>
    )
}

function MainteanceDetail() {
    const { control, watch } = useFormContext<MaintenanceType>()

    const scheduleSelect = [
        { value: "1", label: "Week" },
        { value: "2", label: "Month" },
        { value: "3", label: "Quarter" },
        { value: "4", label: "Year" },
    ]

    const scheduleMap: Record<string, number> = {
        "1": 7,
        "2": 30,
        "3": 90
    };

    const lastMaintenance = watch("last_maintenance")

    const maintenanceDays = scheduleMap[watch("maintenance_schedule")] || 365;
    const nextMaintenanceDate = moment(lastMaintenance).add(maintenanceDays, "days").format("YYYY-MM-DD");

    return (
        <div>
            <div className="font-bold mb-4 bg-slate-400 p-2 dark:text-white rounded-sm">ASSET MAINTENANCE :</div>
            <div className="flex flex-col gap-2">
                <div className="flex gap-2">
                    <Label className="w-[200px]">MAINTENANCE SCHEDULE</Label>
                    <Controller
                        control={control}
                        name="maintenance_schedule"
                        render={({ field, fieldState }) => (
                            <Select
                                placeholder="Select maintenance schedule..."
                                {...field}
                                error={fieldState.error?.message}
                                onChange={e => field.onChange(e?.value)}
                                options={scheduleSelect}
                                value={scheduleSelect.find(item => item.value === field.value?.toString())}
                            />
                        )}
                    />
                </div>

                <div className="flex gap-2">
                    <Label className="w-[200px]">LAST MAINTENANCE DATE</Label>
                    <div className="flex-grow">
                        <Controller
                            control={control}
                            name="last_maintenance"
                            render={({ field, fieldState }) => (
                                <DateInput
                                    {...field}
                                    onChange={(date) => {
                                        field.onChange(moment(date).format("YYYY-MM-DD"))
                                    }}
                                    selected={field.value  ? moment(field.value).toDate() : null}
                                    value={field.value ? moment(field.value).format("DD/MM/YYYY") : ""}
                                    error={fieldState.error?.message}
                                    className="flex-grow"
                                />
                            )}
                        />
                    </div>
                </div>

                <div className="flex gap-2">
                    <Label className="w-[200px]">NEXT MAINTENANCE DATE</Label>
                    <div className="flex-grow">
                        <DateInput
                            onChange={(date) => moment(date).format("YYYY-MM-DD")}
                            selected={moment().toDate()}
                            value={lastMaintenance ? moment(nextMaintenanceDate).format("DD/MM/YYYY") : ""}
                            className="flex-grow"
                            disabled
                        />
                    </div>
                </div>

                <div className="flex gap-2">
                    <Label className="w-[200px]">MAINTENANCE COST</Label>
                    <div className="flex-grow">
                        <Controller
                            control={control}
                            name="maintenance_cost"
                            render={({ field, fieldState }) => (
                                <NumberInput
                                    error={fieldState.error?.message}
                                    onValueChange={e => field.onChange(e.floatValue ?? 0)}
                                    value={field.value}
                                />
                            )}
                        />
                    </div>
                </div>

            </div>
        </div>
    )
}
